<div class="account-form-wrapper">
  <form
    class="form user-login-form user-form v-row"
    #form="ngForm"
    [formGroup]="changePasswordForm"
    (ngSubmit)="changePasword(form)"
    novalidate
  >
    <div class="row">
      <div class="col inner-fields">
        <h2>Change Password</h2>
        <div class="item-fields">
          <label class="hidden-label">Change Password for {{ emailAddress || 'Null' }}'s account</label>
          <div [hidden]="isVerificationCodeValid">
            <span class="alert alert-danger">Please click on the link below to reset your account's password</span>
            <a href="/admin-reset-password?email={{ emailAddress }}">Reset Password</a>
          </div>
          <div [hidden]="!isVerificationCodeValid">
            <div class="form-group">
              <label class="hidden-label">New Password</label>
              <div class="pw-wrapper">
                <input
                  formControlName="password"
                  name="password"
                  type="{{ (changePWType && 'text') || 'password' }}"
                  class="form-control"
                  placeholder="New Password"
                  tabindex="1"
                />
                <div class="description">
                  Password must be at least 8 characters in length containing at least one upper case, one numeric and one special character
                </div>
                <div [hidden]="changePasswordForm.controls['password'].valid">
                  <span
                    [hidden]="
                      !changePasswordForm.controls.password.errors?.required ||
                      (!form.submitted && !changePasswordForm.controls.password.touched)
                    "
                    class="alert alert-danger"
                    >Required</span
                  >
                  <span [hidden]="!changePasswordForm.controls.password.errors?.password" class="alert alert-danger">{{
                    changePasswordForm.controls['password'].errors?.password
                  }}</span>
                </div>
                <span class="float-end m-0 show-password">
                  <button type="button" class="btn-link" (click)="displayPassword()">
                    <i class="fa fa-eye"></i>
                  </button>
                </span>
              </div>
            </div>
            <div class="form-group">
              <label class="hidden-label">Confirm Password</label>
              <div class="pw-wrapper">
                <input
                  formControlName="confirmPassword"
                  name="confirmPassword"
                  type="{{ (changePWType && 'text') || 'password' }}"
                  class="form-control"
                  placeholder="Confirm Password"
                  tabindex="2"
                />
                <div
                  *ngIf="changePasswordForm.controls['confirmPassword'].invalid && changePasswordForm.controls['confirmPassword'].touched"
                  class="alert alert-danger"
                >
                  <span [hidden]="!changePasswordForm.controls.confirmPassword.errors?.required">Please re-type your password.</span>
                </div>
                <div
                  *ngIf="changePasswordForm.errors && (form.submitted || changePasswordForm.controls['confirmPassword'].touched)"
                  class="alert alert-danger"
                >
                  <span [hidden]="!changePasswordForm.errors?.misMatchPasswords">Passwords don't match.</span>
                </div>
                <span class="float-end m-0 show-password">
                  <button type="button" class="btn-link" (click)="displayPassword()">
                    <i class="fa fa-eye icon-lg"></i>
                  </button>
                </span>
              </div>
            </div>
            <div class="form-group text-end m-t">
              <button [loading]="siginingInProgress" type="submit" tabindex="4" class="w-100 m-t text-center btn-md btn-shadow">
                Change Password
              </button>
            </div>
          </div>
          <errors style="position: relative; top: 10px" [on]="signinFormErrors">
            {{ signinFormErrors }}
          </errors>
        </div>
      </div>
    </div>
  </form>
  <div class="powered-by text-center v-row">
    <div>
      Powered by
      <a href="https://cal.lk" target="_blank">CAL</a> | <a href="/terms-and-conditions">Disclaimer</a>
    </div>
  </div>
</div>
